import { Vue, Component, Prop } from 'vue-property-decorator';
import { SliderProps, SlideStruct, SwiperOptions } from './types';

@Component
export class PropsMixin extends Vue implements SliderProps {
    @Prop({ default: 'default-slider' })
    public readonly component!: string;

    @Prop({ default: () => ({}) })
    public readonly sliderOptions!: SwiperOptions;

    @Prop()
    public readonly slides!: SlideStruct[];

    @Prop()
    public readonly url!: string;

    @Prop()
    public readonly parallax!: boolean;

    @Prop()
    public readonly labels!: boolean;

    @Prop()
    public readonly sliderContainerClass!: string;

    @Prop()
    public readonly sliderClass!: string;

    @Prop()
    public readonly slideClass!: string;

    @Prop()
    public readonly sliderActiveSlide!: number;

    @Prop()
    public readonly galleryId!: string;
}
